import {
  ICompleteAuthorizationRequest,
  ICompleteAuthorizationResponse,
} from "../@types/OAuth";
import { ANONYMOUS_REQUEST, api } from "./api";

export const googleHealthService = {
  async completeAuthorization(
    request: ICompleteAuthorizationRequest
  ): Promise<ICompleteAuthorizationResponse> {
    // Anonymous callback page (EN-5229): always the default API, never the
    // regional URL a previous sign-in left in browser storage.
    const response = await api.post<ICompleteAuthorizationResponse>(
      "/Mobile/GoogleHealth/CompleteAuthorization",
      request,
      ANONYMOUS_REQUEST
    );
    return response.data;
  },
};
